import BadRequest from '@/components/Modal/BadRequestModal/BadRequestModal.vue'
import ConfirmModal from '@/components/Modal/ConfirmModal/ConfirmModal.vue'
import { getAllUsers, deleteUser, updateUser, sendReVerificationRequest } from '@/utils/requestHandler.js'

export default {
   name: 'AdminPanel',
   components: {
      BadRequest,
      ConfirmModal
   },
   data() {
      return {
         users: [],
         error: null,
         triageUser: null
      }
   },
   mounted() {
      getAllUsers()
         .then(response => {
            this.users = response.data
            this.users.forEach(user => {
               user.original = JSON.parse(JSON.stringify(user))
            })
         })
         .catch(error => {
            this.error = error
         })
   },
   methods: {
      calculateTimeAgo(milliseconds) {
         let timeAgo = (Date.now() - milliseconds) / 1000
         let timeString = ''
         if (timeAgo < 60) {
            timeString = 'seconds'
         } else if (timeAgo < 60 * 60) {
            timeAgo /= 60
            timeString = 'minutes'
         } else if (timeAgo < 60 * 60 * 24) {
            timeAgo /= 60 * 60
            timeString = 'hours'
         } else {
            timeAgo /= 60 * 60 * 24
            timeString = 'days'
         }
         return Math.round(timeAgo) + ' ' + this.$i18n.t('admin.timeAgo.' + timeString)
      },
      modalConfirm() {
         deleteUser(this.triageUser)
            .then(() => {
               let index = this.users.indexOf(this.triageUser)
               this.users.splice(index, 1)
               this.triageUser = null
            })
            .catch(error => {
               console.error(error.response, this.triageUser)
            })
      },
      confirmDelete(user) {
         this.triageUser = user
      },
      changeValue(newValue, user, value) {
         user[value] = newValue
      },
      isModified(user) {
         let original = user.original
         let modified = false
         Object.keys(original).forEach(key => {
            if (user[key] !== original[key]) {
               modified = true
            }
         })
         return modified
      },
      sendReVerificationRequest(user) {
         sendReVerificationRequest(user).then(() => {
            user.requestedToReVerify = true
            user.original.requestedToReVerify = true
         })
      },
      save(user) {
         if (!this.isModified(user)) return
         let original = user.original
         updateUser(user).then(() => {
            Object.keys(original).forEach(key => {
               original[key] = user[key]
            })
            // Without this, the Save-Button won't be disabled again
            user.id += 1
            user.id -= 1
         })
      }
   }
}
